"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var recompose_1 = require("recompose");
var styled_components_1 = require("styled-components");
var object_1 = require("../../utils/object");
var Box_1 = require("../Box");
var hocs_1 = require("../hocs");
var StyledCheckBox_1 = require("./StyledCheckBox");
var utils_1 = require("../../utils");
var StyledTextInput_1 = require("../TextInput/StyledTextInput");
var CheckBox = /** @class */ (function (_super) {
    tslib_1.__extends(CheckBox, _super);
    function CheckBox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CheckBox.prototype.render = function () {
        var _a = this.props, checked = _a.checked, disabled = _a.disabled, forwardRef = _a.forwardRef, id = _a.id, label = _a.label, name = _a.name, onChange = _a.onChange, reverse = _a.reverse, theme = _a.theme, toggle = _a.toggle, error = _a.error, errorIcon = _a.errorIcon, errorMessage = _a.errorMessage, margin = _a.margin, readOnly = _a.readOnly, size = _a.size, lineHeight = _a.lineHeight, textColor = _a.textColor, rest = tslib_1.__rest(_a, ["checked", "disabled", "forwardRef", "id", "label", "name", "onChange", "reverse", "theme", "toggle", "error", "errorIcon", "errorMessage", "margin", "readOnly", "size", "lineHeight", "textColor"]);
        var visual = toggle ? (React.createElement(StyledCheckBox_1.StyledCheckBoxToggle, { theme: theme, checked: checked, disabled: disabled },
            React.createElement(StyledCheckBox_1.StyledCheckBoxKnob, { theme: theme, checked: checked, disabled: disabled }))) : (React.createElement(StyledCheckBox_1.StyledCheckBoxBox, { align: "center", justify: "center", width: theme && theme.checkBox.size + "px", height: theme && theme.checkBox.size + "px}", border: {
                size: theme && theme.checkBox.border.width,
                color: utils_1.normalizeColor(theme && theme.checkBox.border.color, theme)
            }, round: theme && theme.checkBox.check.radius, theme: theme },
            React.createElement(StyledCheckBox_1.StyledCheckBoxIcon, { viewBox: "0 0 24 24", preserveAspectRatio: "xMidYMid meet", theme: theme },
                React.createElement("path", { fill: "none", d: "M6,11.3 L10.3,16 L18,6.2" }))));
        var checkBoxNode = (React.createElement(StyledCheckBox_1.StyledCheckBox, { align: "center", justify: "center", theme: theme, alignSelf: "start" },
            React.createElement(StyledCheckBox_1.StyledCheckBoxInput, tslib_1.__assign({}, rest, { ref: forwardRef, type: "checkbox" }, object_1.removeUndefined({
                id: id,
                name: name,
                checked: checked,
                disabled: disabled,
                onChange: onChange
            }), { theme: theme, checked: checked, disabled: disabled, toggle: toggle, "aria-invalid": !!error, readOnly: readOnly })),
            visual));
        var normalizedLabel = typeof label === 'string' ? (React.createElement(StyledCheckBox_1.StyledCheckLabel, { theme: theme, size: size, lineHeight: lineHeight, textColor: textColor },
            label,
            " ",
            error && errorIcon)) : (label);
        var first = reverse ? normalizedLabel : checkBoxNode;
        var second = reverse ? checkBoxNode : normalizedLabel;
        return (React.createElement(StyledCheckBox_1.StyledCheckBoxContainer, { margin: margin },
            React.createElement(StyledCheckBox_1.StyledCheckBoxWrapper, tslib_1.__assign({ direction: "row", align: "center", tag: "label", as: Box_1.Box, reverse: reverse }, object_1.removeUndefined({ htmlFor: id, disabled: disabled }), { theme: theme, gap: (theme && theme.checkBox.gap) || 'xsmall', checked: checked, toggle: toggle, onClick: function (event) {
                    if (event.target.type !== 'checkbox') {
                        event.stopPropagation();
                    }
                } }),
                first,
                second),
            error && (React.createElement(StyledTextInput_1.StyledError, { theme: theme, id: id && "error-" + id, textSize: size }, errorMessage))));
    };
    CheckBox.defaultProps = {
        margin: { right: 'xsmall' }
    };
    return CheckBox;
}(React.PureComponent));
exports.default = recompose_1.compose(styled_components_1.withTheme, hocs_1.withForwardRef)(CheckBox);
//# sourceMappingURL=CheckBox.js.map